export const setLanguageInUrl = (languageCode: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('lang', languageCode);
    window.history.replaceState({}, document.title, `${window.location.pathname}?${searchParams}`);
};